<div class="form-container">
  <form class="m-h-12 m-v-32"
    [formGroup]="form">

    <div
      class="mat-typography"
      [attr.aria-label]="'sigt.integration.commenterPlanOfficiel.form.instructions_aria' | translate"
      [innerHTML]="'sigt.integration.commenterPlanOfficiel.form.instructions' | translate">
    </div>

    <div class="custom-label">
      {{ 'sigt.integration.commenterPlanOfficiel.form.prenom' | translate }}
      <span *ngIf="estRequis('prenom')" class="required">*</span>
    </div>
    <mat-form-field appearance="outline" class="d-flex">
      <input
        matInput
        maxlength="50"
        formControlName="prenom"
        [attr.aria-label]="'sigt.integration.commenterPlanOfficiel.form.prenom_aria' | translate" />
      <mat-error *ngIf="form?.controls.prenom.errors?.pattern">{{ valeurInvalide('prenom') }}</mat-error>
      <mat-error *ngIf="form?.controls.prenom.errors?.required">{{ valeurObligatoire('prenom') }}</mat-error>
    </mat-form-field>

    <div class="custom-label">
      {{ 'sigt.integration.commenterPlanOfficiel.form.nom' | translate }}
      <span *ngIf="estRequis('nom')" class="required">*</span>
    </div>
    <mat-form-field appearance="outline" class="d-flex">
      <input matInput
        maxlength="50"
        formControlName="nom"
        class="form-control"
        [attr.aria-label]="'sigt.integration.commenterPlanOfficiel.form.nom_aria' | translate" />
      <mat-error *ngIf="form?.controls.nom.errors?.pattern">{{valeurInvalide('nom')}}</mat-error>
      <mat-error *ngIf="form?.controls.nom.errors?.required">{{valeurObligatoire('nom')}}</mat-error>
    </mat-form-field>

    <div class="custom-label">
      {{ 'sigt.integration.commenterPlanOfficiel.form.courriel' | translate }}
      <span *ngIf="estRequis('courriel')" class="required">*</span>
    </div>
    <mat-form-field appearance="outline" class="d-flex">
      <input matInput
        maxlength="160"
        formControlName="courriel"
        class="form-control"
        [attr.aria-label]="'sigt.integration.commenterPlanOfficiel.form.courriel_aria' | translate" />
      <mat-error *ngIf="form?.controls.courriel.errors?.email">{{valeurInvalide('courriel')}}</mat-error>
      <mat-error *ngIf="form?.controls.courriel.errors?.required">{{valeurObligatoire('courriel')}}</mat-error>
    </mat-form-field>

     <div class="custom-label">
      {{ 'sigt.integration.commenterPlanOfficiel.form.positionSurCarte' | translate }}
      <span *ngIf="estRequis('positionSurCarte')" class="required">*</span>
    </div>
    <mat-form-field id="positionSurCarte" appearance="outline"class="d-flex">
      <input matInput
        readonly
        formControlName="positionSurCarteForViewOnly"
        class="form-control"
        [attr.aria-label]="'sigt.integration.commenterPlanOfficiel.form.positionSurCarte_aria' | translate" />
      <mat-icon matSuffix
        (click)="initialiserPositionCarte()">place</mat-icon>
      <mat-hint [ngClass]="{positionSurCarteVide: form?.controls.positionSurCarteForViewOnly.value === ''}">{{
        'sigt.integration.commenterPlanOfficiel.form.positionSurCarteHint' | translate }}</mat-hint>
    </mat-form-field>

    <div class="custom-label">
      {{ 'sigt.integration.commenterPlanOfficiel.form.commentaire.libelle' | translate }}
      <span *ngIf="estRequis('commentaire')" class="required">*</span>
    </div>
    <mat-form-field appearance="outline" class="d-flex tailletextArea">
      <textarea matInput
        #commentaire
        formControlName="commentaire"
        maxlength="4000"
        [attr.aria-label]="'sigt.integration.commenterPlanOfficiel.form.commentaire.libelle_aria' | translate"></textarea>
      <mat-error *ngIf="form?.controls.commentaire.errors?.pattern">{{valeurInvalide('commentaire')}}</mat-error>
      <mat-error *ngIf="form?.controls.commentaire.errors?.minlength">{{messageApplication.minCommentaire}}</mat-error>
      <mat-error *ngIf="form?.controls.commentaire.errors?.required">{{valeurObligatoire('commentaire')}}</mat-error>
      <mat-hint>{{ 'sigt.integration.commenterPlanOfficiel.form.commentaire.libelleTailleMax' | translate }}</mat-hint>
    </mat-form-field><br>

     <div class="custom-label">
      {{ 'sigt.integration.commenterPlanOfficiel.form.codeCaptcha' | translate }}
      <span *ngIf="estRequis('textCaptcha')" class="required">*</span>
    </div>
    <div class="divCaptcha"
      *ngIf="(captcha | async) as captchaImg">
      <mat-form-field appearance="outline" class="d-flex">
        <input matInput
          formControlName="textCaptcha"
          class="form-control"
          [attr.aria-label]="'sigt.integration.commenterPlanOfficiel.form.codeCaptcha_aria' | translate" />
        <mat-error *ngIf="form?.controls.textCaptcha.errors?.captcha">{{
          'sigt.integration.commenterPlanOfficiel.form.messagesPlaceholders.invalideCaptchaCode' | translate
          }}</mat-error>
        <mat-error *ngIf="form?.controls.textCaptcha.errors?.required">{{valeurObligatoire('captcha')}}</mat-error>
      </mat-form-field>

      <img [src]="captchaImg" />

      <button mat-raised-button
        (click)="obtenirCode()">
        {{ 'sigt.global.boutons.recharger' | translate }}
      </button>

    </div>

    <br>

    <div class="boutons-en-grille">
      <button mat-raised-button
        class="clear-search-button"
        (click)="initialiserChamps()"
        [attr.aria-label]="'sigt.integration.commenterPlanOfficiel.form.annuler_aria' | translate">
        {{ 'sigt.global.boutons.annuler' | translate }}
      </button>

      <button mat-raised-button
        class="search-button"
        [disabled]="!form.valid"
        (click)="soumettre()"
        color="primary"
        [attr.aria-label]="'sigt.integration.commenterPlanOfficiel.form.soumettre_aria' | translate">
        {{ 'sigt.global.boutons.soumettre' | translate }}
      </button>
    </div>

    <igo-geometry-form-field-input [formControl]="form.controls.positionSurCarte"
      [map]="map"
      [geometryType]="geometryType"
      [drawGuide]="1000"
      [measure]="false"
      [drawControlIsActive]="true"
      [freehandDrawIsActive]="false"
      [drawStyle]="drawStyle$ | async"
      [radius]="radius"></igo-geometry-form-field-input>
  </form>
</div>
